import { render, staticRenderFns } from "./StatisticsDetail.vue?vue&type=template&id=3db41d21&scoped=true"
import script from "./StatisticsDetail.vue?vue&type=script&lang=js"
export * from "./StatisticsDetail.vue?vue&type=script&lang=js"
import style0 from "./StatisticsDetail.vue?vue&type=style&index=0&id=3db41d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db41d21",
  null
  
)

export default component.exports